<template>
  <div class="px-4">
    <section class="max-w-6.5xl mx-auto py-18">
      <div class="bg-blue-50 p-7 sm:p-20 rounded-[10px] flex flex-col lg:flex-row">
        <div class="flex-1 pr-20">
          <h2 class="h2 text-gray-900 font-alt whitespace-pre">{{ title }}</h2>
          <p class="text-gray-600 text-lg mt-4.5 tracking-wide whitespace-pre-line">{{ description }}</p>
        </div>

        <div class="flex-1 mt-10 lg:mt-0">
          <AdvantageOurValuesItem
            v-for="{ iconName, name, description } in items"
            class="mb-[2.365rem] last:mb-0"
            :key="name"
            :icon-name="iconName"
            :name="name"
            :description="description"
            :icon-size="iconSize"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { AdvantageIconSizeType, AdvantageItemsType, AdvantageSpaceYType } from '@/types/advantage-types'

const props = defineProps({
  title: {
    type: String as PropType<string>,
    default: '',
  },
  description: {
    type: String as PropType<string>,
    default: '',
  },
  items: {
    type: Array as PropType<AdvantageItemsType>,
    default: () => [],
  },
  iconSize: {
    type: String as PropType<AdvantageIconSizeType>,
    default: 'medium',
  },
})
</script>
